import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as feather from 'feather-icons';
import { NavService } from '../../../services/nav.service';
import { LayoutService } from '../../../services/layout.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit, AfterViewInit {
  public currentRoute: string = '';
  public right_side_bar: boolean;

  constructor(public navServices: NavService, public layout: LayoutService, private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.urlAfterRedirects;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      feather.replace();
    });
  }

  ngOnInit() {
  }

  // Activate route function
  public getRouterOutletState(outlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  // Sidebar function
  public rightSidebar($event) {
    this.right_side_bar = $event;
  }

  // Wtite css for the route fuction
  public shouldShowNavbar(): boolean {
    return !this.currentRoute.includes('/questionnarie/');
  }

}

